export default {
  API_ROOT: process.env.REACT_APP_API_ROOT,
  PUBLIC_DSN: process.env.REACT_APP_PUBLIC_DSN,
  SPLIT_AUTH_KEY: process.env.REACT_APP_SPLIT_AUTH_KEY,
  SPLIT_KEY: process.env.REACT_APP_SPLIT_KEY,
  WEBFLOW_URL: process.env.REACT_APP_WEBFLOW_URL,
  SCHEDULER_URL: process.env.REACT_APP_SCHEDULER_URL,
  INSTALL_TOOL_URL: process.env.REACT_APP_INSTALL_TOOL_URL,
};
